import { Link, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthLayout, Button, Card, ErrorMessage, Field, Input, PasswordInput } from '../components/ui.tsx';
import { authClient } from '../lib/auth-client.ts';

export function SignUpPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setLoading(true);

    const { error: signUpError } = await authClient.signUp.email({ name, email, password });

    setLoading(false);

    if (signUpError) {
      // Aquí sí se muestra el motivo: el usuario necesita saber si la
      // contraseña es corta o si ya tiene cuenta, y está creando la suya.
      setError(signUpError.message ?? t('auth.signUp.failed'));
      return;
    }

    await navigate({ to: '/organizaciones' });
  }

  return (
    <AuthLayout>
      <Card title={t('auth.signUp.title')}>
        <form onSubmit={handleSubmit} noValidate>
          <ErrorMessage>{error}</ErrorMessage>

          <Field id="name" label={t('common.name')}>
            <Input
              id="name"
              autoComplete="name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Field>

          <Field id="email" label={t('common.email')}>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>

          <Field id="password" label={t('common.password')} hint={t('auth.signUp.passwordHint')}>
            <PasswordInput
              id="password"
              autoComplete="new-password"
              minLength={12}
              required
              aria-describedby="password-hint"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>

          <Button type="submit" loading={loading}>
            {loading ? t('common.loading') : t('auth.signUp.submit')}
          </Button>
        </form>

        <p className="mt-5 text-center text-sm text-[var(--color-muted)]">
          {t('auth.signUp.haveAccount')}{' '}
          <Link to="/entrar" className="text-[var(--color-brand)] underline">
            {t('auth.signUp.signIn')}
          </Link>
        </p>
      </Card>
    </AuthLayout>
  );
}
